import { bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import _ from "lodash";
import { ApplicationState } from "../../../../../../store";
import { EvidencePeriodData, EvidenceType } from "../../../../../../store/onboarding/types";
import {
  changeStudentDSEGrade,
  deleteEvidenceColumnsGroup,
  getDataPeriods,
  getEvidenceInDataPeriod,
  getInterviews,
  getStudents,
  getSchools,
  getTeachers,
  hideViewBenchmarksModal,
  openLoadKeyModal,
  openViewBenchmarksModal,
  setValueOfDSEtoDataPeriod,
  updateValueOfDSEtoDataPeriod,
  getAllClasses,
  getClassesLinkedToStudent,
  deleteDataStudentEntry,
  getRaceInfo,
  setDiagnosticFollowUptoDataPeriod,
  deleteDiagnosticFollowUptoDataPeriod,
} from "../../../../../../store/onboarding/actions";
import {
  addStudentsToNewGroup,
  clickGotIt,
} from "../../../../../../store/onboarding/cases/actions";
import { hideSkillFocusesModal } from "../../../../../../store/groups/actions";
import { showConfirmDialog } from "../../../../../../store/confirm-dialog/actions";
import { columnSortApplied } from "../../../../../../store/dataSort/actions";
import {
  dataFilterApplied,
  resetFilterAction,
  resetPagination,
  resetSortAction,
} from "../../../../../../store/dataFilter/actions";
import * as React from "react";
import { PropsFromState, DispatchProps, OwnProps, Props } from "./Types";

/**
 * mapStateToProps / mapDispatchToProps for EvidenceTable, extracted verbatim
 * (no logic changes) purely to reduce the size of the main component file.
 */

export const mapStateToProps = ({
  onboarding,
  cases,
  dataFilter,
  help,
  dataSort,
  auth,
}: ApplicationState): PropsFromState => {
  let evidencePeriodData: EvidencePeriodData | undefined = _.cloneDeep(
    onboarding.evidencePeriodData!
  );
  if (evidencePeriodData) {
    evidencePeriodData = {
      ...evidencePeriodData,
      student_rows: evidencePeriodData.student_rows.sort((a, b) =>
        a.id > b.id ? 1 : -1
      ),
    };
  }
  const diagnosticInfoECG =
    !!evidencePeriodData &&
    evidencePeriodData?.evidence_column_groups?.find(
      (ecg) =>
        !ecg.assessment &&
        ecg.evidence_columns.some(
          (ec) => ec.evidence_type === EvidenceType.DiagnosticInfo
        )
    );

  if (diagnosticInfoECG && evidencePeriodData) {
    evidencePeriodData = {
      ...evidencePeriodData,
      evidence_column_groups: evidencePeriodData.evidence_column_groups.sort(
        (a, b) => (b.id === diagnosticInfoECG.id ? -1 : 0)
      ),
    };
  }
  if (
    onboarding.teacherClassStudent &&
    Object.keys(onboarding.teacherClassStudent).length
  ) {
    for (let i = 0; i < evidencePeriodData!.student_rows?.length; i++) {
      onboarding.teacherClassStudent!.students.length &&
        onboarding.teacherClassStudent!.students.map((tcs: any, index: number) => {
          if (evidencePeriodData!.student_rows[i].student.id == tcs.id) {
            evidencePeriodData!.student_rows[i].student = {
              ...evidencePeriodData!.student_rows[i].student,
              teachers: tcs.teachers,
            };
          }
        });
    }
    onboarding.teacherClassStudent = {};
  }
  return {
    showTopBar: help.showTopBar,
    isCompressedViewOfDataTable: help.isCompressedViewOfDataTable,
    showGroupingStudentInfo: cases.showGroupingStudentInfo,
    errors: {
      getEvidenceData: onboarding.errors.getEvidenceInDatePeriod,
      addAssessmentToDataPeriod: onboarding.errors.addAssessmentToDataPeriod,
      addStudentsToDataPeriod: onboarding.errors.addStudentsToDataPeriod,
      setValueOfDSEtoDataPeriod: onboarding.errors.setValueOfDSEtoDataPeriod,
      updateValueOfDSEtoDataPeriod: onboarding.errors.updateValueOfDSEtoDataPeriod,
      setDiagnosticFollowUptoDataPeriod:
        onboarding.errors.setDiagnosticFollowUptoDataPeriod,
      deleteDiagnosticFollowUptoDataPeriod:
        onboarding.errors.deleteDiagnosticFollowUptoDataPeriod,
      uploadAssessmentData: onboarding.errors.uploadAssessmentData,
      uploadUndefinedAssessmentData: onboarding.errors.uploadUndefinedAssessmentData,
      uploadEvidenceData: onboarding.errors.uploadEvidenceData,
      deleteEvidenceColumnsGroup: onboarding.errors.deleteEvidenceColumnsGroup,
      changeStudentDSEGrade: onboarding.errors.changeStudentDSEGrade,
      addStudentBehaviorsToDataPeriod:
        onboarding.errors.addStudentBehaviorsToDataPeriod,
      addTargetBehaviorToDataPeriod: onboarding.errors.addTargetBehaviorToDataPeriod,
      updateStudentDetails: onboarding.errors.updateStudentDetails,
      addStudents: onboarding.errors.addStudents,
      updateCustomColorCriteria: onboarding.errors.updateCustomColorCriteria,
    },
    isLoading: {
      getEvidenceData: onboarding.isLoading.getEvidenceInDatePeriod,
      getDataPeriods: onboarding.isLoading.getDataPeriods,
      addAssessmentToDataPeriod: onboarding.isLoading.addAssessmentToDataPeriod,
      addStudentsToDataPeriod: onboarding.isLoading.addStudentsToDataPeriod,
      updateStudentDetails: onboarding.isLoading.updateStudentDetails,
      setValueOfDSEtoDataPeriod: onboarding.isLoading.setValueOfDSEtoDataPeriod,
      setDiagnosticFollowUptoDataPeriod:
        onboarding.isLoading.setDiagnosticFollowUptoDataPeriod,
      addStudentBehaviorsToDataPeriod:
        onboarding.isLoading.addStudentBehaviorsToDataPeriod,
      updateValueOfDSEtoDataPeriod: onboarding.isLoading.updateValueOfDSEtoDataPeriod,
      deleteDiagnosticFollowUptoDataPeriod:
        onboarding.isLoading.deleteDiagnosticFollowUptoDataPeriod,
      uploadAssessmentData: onboarding.isLoading.uploadAssessmentData,
      uploadUndefinedAssessmentData:
        onboarding.isLoading.uploadUndefinedAssessmentData,
      uploadEvidenceData: onboarding.isLoading.uploadEvidenceData,
      deleteEvidenceColumnsGroup: onboarding.isLoading.deleteEvidenceColumnsGroup,
      changeStudentDSEGrade: onboarding.isLoading.changeStudentDSEGrade,
      addStudentSkills: onboarding.isLoading.addStudentSkills,
      deleteDataStudentEntry: onboarding.isLoading.deleteDataStudentEntry,
      addTargetBehaviorToDataPeriod:
        onboarding.isLoading.addTargetBehaviorToDataPeriod,
      addExistingBehaviorEcgToDataPeriod:
        onboarding.isLoading.addExistingBehaviorEcgToDataPeriod,
      addBehaviorScreenerEcgToDataPeriod:
        onboarding.isLoading.addBehaviorScreenerEcgToDataPeriod,
      assignTeachersToStudent: onboarding.isLoading.assignTeachersToStudent,
      updateClassesLinkedToStudent: onboarding.isLoading.updateClassesLinkedToStudent,
      updateCustomColorCriteria: onboarding.isLoading.updateCustomColorCriteria,
      updateAssessment: onboarding.isLoading.updateAssessment,
      createDiagnosticInfoColumn: onboarding.isLoading.createDiagnosticInfoColumn,
      getSchoolsList: onboarding.isLoading.getSchoolsList,
      addStudents: onboarding.isLoading.addStudents,
    },
    evidencePeriodData: evidencePeriodData,
    currentDataPeriod: onboarding.currentDataPeriod,
    teacherIdFilter: onboarding.teacherIdFilter,
    schoolIdsFilter: dataFilter.dataSchoolsFilter,
    teacherIdsFilter: dataFilter.dataTeachersFilter,
    selectedClass: onboarding.selectedClass,
    selectedStudent: onboarding.selectedStudent,
    newGroupStudents: cases.newGroupStudents,
    gradeLevelFilter: dataFilter.dataGradesFilter,
    classFilter: dataFilter.classIdFilter,
    studentsFilter: onboarding.studentsFilter,
    isEnterSpecificSkillActive: cases.isEnterSpecificSkillActive,
    hasDiagnosticInfo: !!diagnosticInfoECG,
    studentInterventionGroups: cases.studentInterventionGroups,
    dataSort: dataSort,
    userInfo: auth.userInfo,
    raceFilter: dataFilter.raceFilter,
    raceOtherFilter: dataFilter.raceOtherFilter,
    genderFilter: dataFilter.genderFilter,
    specialEducationFilter: dataFilter.specialEducationFilter,
    ellFilter: dataFilter.ellFilter,
    sldFilter: dataFilter.sldFilter,
    freeOrReducedLunchFilter: dataFilter.freeOrReducedLunchFilter,
    schools: onboarding.schools,
    raceInfo: onboarding.raceInfo,
    isDataFilterApplied: dataFilter.isDataFilterApplied,
    // activeSort: dataSort?.activeSort,
    // allColoumnFields: dataSort?.allColoumnFields,
    loadTableFromSetGoal: cases.loadTableFromSetGoal,
    userDismissPopupDetails: auth.userInfo?.user_dismiss_pop_up_details,
  };
};

export const mapDispatchToProps = (dispatch: Dispatch): DispatchProps =>
  bindActionCreators(
    {
      getTeachers: getTeachers,
      getSchools: getSchools,
      getDataPeriods: getDataPeriods,
      getEvidenceInDataPeriod: getEvidenceInDataPeriod,
      deleteEvidenceColumnsGroup: deleteEvidenceColumnsGroup,
      openViewBenchmarksModal: openViewBenchmarksModal,
      hideViewBenchmarksModal: hideViewBenchmarksModal,
      hideSkillFocusesModal: hideSkillFocusesModal,
      getStudents: getStudents,
      setValueOfDSEtoDataPeriod: setValueOfDSEtoDataPeriod,
      updateValueOfDSEtoDataPeriod: updateValueOfDSEtoDataPeriod,
      setDiagnosticFollowUptoDataPeriod: setDiagnosticFollowUptoDataPeriod,
      deleteDiagnosticFollowUptoDataPeriod: deleteDiagnosticFollowUptoDataPeriod,
      addStudentsToNewGroup: addStudentsToNewGroup,
      changeStudentDSEGrade: changeStudentDSEGrade,
      clickGotIt: clickGotIt,
      openLoadKeyModal: openLoadKeyModal,
      getInterviews: getInterviews,
      getAllClasses: getAllClasses,
      getClassesLinkedToStudent: getClassesLinkedToStudent,
      showConfirmDialog: showConfirmDialog,
      deleteStudentEntry: deleteDataStudentEntry,
      getRaceInfo: getRaceInfo,
      columnSortApplied: columnSortApplied,
      dataFilterApplied: dataFilterApplied,
      resetPagination: resetPagination,
      resetFilterAction: resetFilterAction,
      resetSortAction: resetSortAction,
    },
    dispatch
  );

export const connectEvidenceTable = (component: React.ComponentType<Props>) =>
  connect(mapStateToProps, mapDispatchToProps)(withRouter(component)) as React.ComponentType<OwnProps>;
